// extracted by mini-css-extract-plugin
export default {"cls1":"bzdQHuAdhAOik7CfxwO5","cls2":"oNHRNpiA46nCx6dWhMc7 bzdQHuAdhAOik7CfxwO5","isPhone":"JehluSJQb3eXt2TagY3C"};